import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import Title from '../general/title'
import settings from "settings"
import { Pie, HorizontalBar, Bar, Doughnut } from 'react-chartjs-2'
import GoogleMapReact from 'google-map-react'
import colorArray from '../../helpers/colorArray'
import moment from 'moment'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'

const Marker = () => (
	<div className="map__marker"></div>
)

const columns = [{
		Header: 'Address',
		accessor: 'address',
		Cell: ({ row }) => (<Link to={{ pathname: `/sales/${row.id}` }}>{row.address}</Link>)
	},
	{
		Header: 'Builder',
		accessor: 'builder',
	},
	{
		Header: 'Price',
		accessor: 'price',
		Cell: props => '$' + props.value.toLocaleString()
	},
	{
		Header: 'Sale Date',
		accessor: 'sale_date',
		Cell: props => moment.unix(props.value).format('MM/DD/YY'),
		sort: 'asc'
	},
	{
		Header: 'Closed',
		accessor: 'closed',
	},
	{
		Header: 'id',
		accessor: 'id',
		show: false
	}
]

class ZipCode extends Component {

	constructor(props) {
		super(props)
		this.state = {
			zip: parseInt(this.props.match.params.zip)
		}
	}

	salesCount = () => {
		var count = 0
		if (_.has(this.props, 'payload.sales.current')) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (r.zip == this.state.zip) {
					count++
				}
			})
		}
		return count
	}

	closingCount = () => {
		var count = 0
		if (_.has(this.props, 'payload.closings.current')) {
			_.forEach(this.props.payload.closings.current, (r) => {
				if (r.zip == this.state.zip) {
					count++
				}
			})
		}
		return count
	}

	trafficCount = () => {
		if (_.has(this.props, `payload.traffic.zips[${this.state.zip}].count`)) {
			return this.props.payload.traffic.zips[this.state.zip].count
		}
		return 0
	}

	closingPercent = () => {
		var sales = this.salesCount()
		var closings = this.closingCount()

		if (sales && closings) {
			return Math.ceil((closings / sales) * 100)
		}
		return 0
	}

	ageRange() {
		var c = {}
		_.forEach(this.props.payload.sales.current, (row) => {
			if (row.zip !== this.state.zip) { return }
			if (!row.age_range) { return }
			if (!_.has(c, row.age_range)) {
				c[row.age_range] = 0
			}
			c[row.age_range]++
		})
		const data = {
			labels: _.keys(c),
			datasets: [{
				data: _.values(c),
				backgroundColor: colorArray
			}],
		}

		const opts = {
			legend: {
				display: true,
				position: 'bottom'
			}
		}

		return (<Pie data={data} options={opts} />)
	}

	ethnicity() {
		var c = {}
		_.forEach(this.props.payload.sales.current, (row) => {
			if (row.zip !== this.state.zip) { return }
			if (!row.ethnicity) { return }
			if (!_.has(c, row.ethnicity)) {
				c[row.ethnicity] = 0
			}
			c[row.ethnicity]++
		})

		const data = {
			labels: _.keys(c),
			datasets: [{
				data: _.values(c),
				backgroundColor: colorArray
			}],
		}

		const opts = {
			legend: {
				display: true,
				position: 'bottom'
			}
		}

		return (<Pie data={data} options={opts} />)
	}

	firstTime() {
		var c = {}
		_.forEach(this.props.payload.sales.current, (row) => {
			if (row.zip !== this.state.zip) { return }
			var flag = (row.first_time == 0 ? 'Yes' : 'No')
			if (!_.has(c, flag)) {
				c[flag] = 0
			}
			c[flag]++
		})

		const data = {
			labels: _.keys(c),
			datasets: [{
				data: _.values(c),
				backgroundColor: colorArray
			}],
		}

		const opts = {
			legend: {
				display: true,
				position: 'bottom'
			}
		}

		return (<Pie data={data} options={opts} />)
	}

	children() {
		var c = {}
		_.forEach(this.props.payload.sales.current, (row) => {
			if (row.zip !== this.state.zip) { return }
			var flag = (!row.children_ages ? 'No' : 'Yes')
			if (!_.has(c, flag)) {
				c[flag] = 0
			}
			c[flag]++
		})

		const data = {
			labels: _.keys(c),
			datasets: [{
				data: _.values(c),
				backgroundColor: colorArray
			}],
		}

		const opts = {
			legend: {
				display: true,
				position: 'bottom'
			}
		}

		return (<Pie data={data} options={opts} />)
	}

	childrenAges() {
		var c = {}

		_.forEach(this.props.payload.sales.current, (row) => {
			if (row.zip !== this.state.zip) { return }
			var parsed = {}
			if (row.children_ages) {
				console.log(row.children_ages)
				parsed = row.children_ages
			}

			_.forEach(parsed, (p) => {
				if (!_.has(c, p)) {
					c[p] = 0
				}
				c[p]++
			})
		})

		const data = {
			labels: _.keys(c),
			datasets: [{
				data: _.values(c),
				backgroundColor: colorArray
			}],
		}

		const opts = {
			legend: {
				display: true,
				position: 'bottom'
			}
		}

		return (<Pie data={data} options={opts} />)
	}

	buildDemo = () => {

		return (
			<div>
				<div className="statBox__row statBox__row--double">
					<div className="statBox__box">
						<h3 className="statBox__title">Age Range</h3>
						{this.ageRange()}
					</div>
					<div className="statBox__box">
						<h3 className="statBox__title">Ethnicity</h3>
						{this.ethnicity()}
					</div>
				</div>
				<div className="statBox__row statBox__row--double">
					<div className="statBox__box">
						<h3 className="statBox__title">First Time</h3>
						{this.firstTime()}
					</div>
					<div className="statBox__box">
						<h3 className="statBox__title">Children</h3>
						{this.children()}
					</div>
				</div>
				<div className="statBox__row statBox__row--double">
					<div className="statBox__box">
						<h3 className="statBox__title">Children Ages</h3>
						{this.childrenAges()}
					</div>
					
				</div>
			</div>
		)
	}

	buildMap = () => {
		if (_.has(this.props, `payload.traffic.zips[${this.state.zip}]`)) {
			return (
				<div className="content">
					<h2>Zip Code Location</h2>
					<div className="map">
						<GoogleMapReact
							bootstrapURLKeys={{
								key: settings.gmapsApiKey,
								libraries: 'visualization'
							}}
							defaultCenter={{
								lat: this.props.payload.traffic.zips[this.state.zip].lat,
								lng: this.props.payload.traffic.zips[this.state.zip].lng
							}}
							defaultZoom={11}
							heatmap={this.state.heat}
						>
							<Marker
								lat={this.props.payload.traffic.zips[this.state.zip].lat}
								lng={this.props.payload.traffic.zips[this.state.zip].lng}
							/>
						</GoogleMapReact>
					</div>
				</div>
			)
		} else {
			return ('')
		}
	}

	buildTable = () => {
		var data = []
		if (_.has(this.props, 'payload.sales.current')) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (r.zip !== this.state.zip) { return }
				let builder = _.find(this.props.payload.public.builders.children, {id: r.builder})
				data.push({
					builder: builder.name,
					closed: (r.closed == 0) ? 'No' : 'Yes',
					price: r.price,
					sale_date: r.sale_date,
					address: r.address,
					id: r.id
				})
			})
			return data
		}
		return []
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="zipcode">
					<Title title={`Zip Code Report for ${this.state.zip}`} />
					<div className="zipCode">
						<div className="statBreakout">
							<div className="statBreakout__group">
								<ul className="statBreakout__list">
									<li className="statBreakout__item">
										<div>
											<div className="statBreakout__stat">{this.salesCount()}</div>
											<div className="statBreakout__info">Sales</div>
										</div>
									</li>
									<li className="statBreakout__item">
										<div>
											<div className="statBreakout__stat">{this.closingCount()}</div>
											<div className="statBreakout__info">Closings</div>
										</div>
									</li>
									<li className="statBreakout__item">
										<div>
											<div className="statBreakout__stat">{this.closingPercent()}%</div>
											<div className="statBreakout__info">Closing Percentage</div>
										</div>
									</li>
									<li className="statBreakout__item">
										<div>
											<div className="statBreakout__stat">{this.trafficCount()}</div>
											<div className="statBreakout__info">Traffic Entries</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
						{this.buildMap()}
						<div className="content">
							<h2>Demographics</h2>
							{this.buildDemo()}
						</div>
						<div className="content">
							<h2>Sales</h2>
							<ReactTable
								data={this.buildTable()}
								columns={columns}
								loadingText=""
								defaultPageSize={10}
								defaultSorted={[
									{
										id: "sale_date",
										desc: true,
									},
								]}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ('')
		}
	}

}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ZipCode)